import { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { FaAddressCard } from 'react-icons/fa';
import { doc, getDoc, updateDoc, getDocs, collection } from 'firebase/firestore';
import { db } from '../../services/firebaseConnection';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';


export default function EditUser() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [name, setName] = useState('');
  const [genero, setGenero] = useState('');
  const [dataNasc, setDataNasc] = useState('');
  const [celular, setCelular] = useState('');
  const [email, setEmail] = useState('');
  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [cargoSelecionado, setCargoSelecionado] = useState('');
  const [igrejaSelecionada, setIgrejaSelecionada] = useState('');

  const [cidade, setCidade] = useState([]);
  const [cargo, setCargo] = useState([]);
  const [igreja, setIgreja] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userRef = doc(db, 'User', id);
        const userSnapshot = await getDoc(userRef);

        if (userSnapshot.exists()) {
          const userData = userSnapshot.data();
          setName(userData.name);
          setGenero(userData.genero);
          setDataNasc(userData.datanasc);
          setCelular(userData.celular);
          setEmail(userData.email);
          setCidadeSelecionada(userData.cidade);
          setCargoSelecionado(userData.cargo);
          setIgrejaSelecionada(userData.igreja);
        } else {
          toast.error('Usuário não encontrado.');
          navigate('/user');
        }

      } catch (error) {
        console.error('Erro ao carregar usuário:', error);
        toast.error('Erro ao carregar os dados do usuário.');
      }
    }

    async function loadOptions() {
      try {
        // Carrega opções de Cidade, Cargo e Igreja
        const [cidadeSnapshot, cargoSnapshot, igrejaSnapshot] = await Promise.all([
          getDocs(collection(db, 'Cidade')),
          getDocs(collection(db, 'Cargo')),
          getDocs(collection(db, 'Igreja')),
        ]);

        setCidade(cidadeSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        setCargo(cargoSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        setIgreja(igrejaSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error('Erro ao carregar opções:', error);
      }
    }

    fetchData();
    loadOptions();
  }, [id, navigate]);

  async function handleUpdate(e) {
    e.preventDefault();

    if (name && email && genero && cidadeSelecionada && cargoSelecionado && igrejaSelecionada) {
      const userData = {
        name: name,
        genero: genero,
        celular: celular,
        datanasc: dataNasc,
        email: email,
        cargo: cargoSelecionado,
        cidade: cidadeSelecionada,
        igreja: igrejaSelecionada,
      };

      try {
        const userRef = doc(db, 'User', id);
        await updateDoc(userRef, userData);
        toast.success('Usuário atualizado com sucesso!');
        navigate('/user');
      } catch (error) {
        console.error('Erro ao atualizar usuário:', error);
        toast.error('Erro ao atualizar usuário.');
      }
    } else {
      toast.error('Preencha todos os campos!');
    }
  }

  return (
    <div>
      <Header />

      <div className="content">
        <Title name="Editar Usuário">
          <FaAddressCard size={25} />
        </Title>

        <div className="container">
          <form onSubmit={handleUpdate}>
            <label>Nome</label>
            <input
              type="text"
              placeholder="Nome completo"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <label>Número do Celular</label>
            <input
              type="number"
              placeholder="Número do Celular"
              value={celular}
              onChange={(e) => setCelular(e.target.value)}
            />

            <label>Gênero</label>
            <select value={genero} onChange={(e) => setGenero(e.target.value)}>
              <option value="" disabled>
                Selecione
              </option>
              <option value="masculino">Masculino</option>
              <option value="feminino">Feminino</option>
            </select>

            <label>Data de Nascimento</label>
            <input
              type="date"
              value={dataNasc}
              onChange={(e) => setDataNasc(e.target.value)}
            />

            <label>Cidade</label>
            <select
              value={cidadeSelecionada}
              onChange={(e) => setCidadeSelecionada(e.target.value)}
            >
              <option value="">Selecione uma cidade</option>
              {cidade.map((cidade) => (
                <option key={cidade.id} value={cidade.id}>
                  {cidade.nome}
                </option>
              ))}
            </select>

            <label>Cargo</label>
            <select
              value={cargoSelecionado}
              onChange={(e) => setCargoSelecionado(e.target.value)}
            >
              <option value="">Selecione um cargo</option>
              {cargo.map((cargo) => (
                <option key={cargo.id} value={cargo.id}>
                  {cargo.nome}
                </option>
              ))}
            </select>

            <label>Casa de Oração</label>
            <select
              value={igrejaSelecionada}
              onChange={(e) => setIgrejaSelecionada(e.target.value)}
            >
              <option value="">Selecione uma Casa de Oração</option>
              {igreja.map((igreja) => (
                <option key={igreja.id} value={igreja.id}>
                  {igreja.nome}
                </option>
              ))}
            </select>

            <label>Username</label>
            <input
              type="text"
              placeholder="username"
              value={email}
            />

            <button
              type="button"
              className='resetar-senha'
              onClick={async () => {
                try {
                  const userRef = doc(db, 'User', id);
                  const hashedPassword = bcrypt.hashSync('123456', 10); // Criptografa a senha padrão
                  await updateDoc(userRef, { password: hashedPassword });

                  // Verifique se o campo 'password' foi realmente atualizado
                  const updatedUserSnapshot = await getDoc(userRef);
                  if (updatedUserSnapshot.exists()) {
                    const userData = updatedUserSnapshot.data();

                    if (bcrypt.compareSync('123456', userData.password)) {
                      toast.success('Senha resetada para 123456.');
                    } else {
                      toast.error('Senha não foi atualizada corretamente.');
                    }
                  }
                } catch (error) {
                  console.error('Erro ao resetar senha:', error);
                  toast.error('Erro ao resetar senha.');
                }
              }}
            >
              Resetar Senha
            </button>
            <button type="submit">Atualizar</button>

          </form>
        </div>
      </div>
    </div>
  );
}
